<template>
  <v-container fluid>
    <v-card dense>
      <v-card-actions dense class="error lighten-2">
        <Category
          Category="Inventory"
          :loadFunction="loadCategories"
          :AccountType="10"
        ></Category>
        <v-spacer></v-spacer>
        <v-text-field
          solo-inverted
          outlined
          name="SearchItem"
          label="Search"
          v-model="search"
          append-icon="fas fa-search"
        ></v-text-field>
      </v-card-actions>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" md="7" lg="8">
            <v-data-table
              :search="search"
              :loading="loading"
              :items="AllInventory"
              :headers="headers"
              :items-per-page="10"
              class="elevation-12"
            >
              <template v-slot:[`item.edite`]="{ item }">
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="InvEdite(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
          <v-col col="12" md="5" lg="4">
            <v-card class="elevation-12">
              <v-toolbar dark color="teal darken-3">
                <v-toolbar-title>Register New Item</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="InventoryForm">
                  <v-select
                    :loading="loadCtgory"
                    outlined
                    :rules="[rules.required]"
                    :items="Gategories"
                    item-value="_id"
                    item-text="AccountName"
                    v-model.trim="NewAccount.InvCateg"
                    label="Gategory"
                  ></v-select>

                  <v-text-field
                    outlined
                    v-model.trim="NewAccount.InvName"
                    :rules="[rules.required]"
                    label="Inventory name"
                    id="InventoryName"
                    @keyup.native.enter="UpdateOrSave"
                  ></v-text-field>

                  <v-select
                    outlined
                    :loading="loadUnit"
                    v-model="NewAccount.UnitType"
                    :items="UintType"
                    item-value="UnitType"
                    item-text="UnitType"
                    label="Unit Type"
                    prepend-inner-icon="fas fa-plus"
                    @click:prepend-inner="AddUnitType"
                  ></v-select>
                  <BaseNumInput
                    :rules="[v => v >= 1 || 'Unit Qty greater or equal to 1']"
                    outlined
                    :label="`${NewAccount.UnitType || 'Unit'} QTY`"
                    v-model.number="NewAccount.UnitQty"
                    @keyup.native.enter="UpdateOrSave"
                  ></BaseNumInput>

                  <p
                    class="font-weight-black mt-3 text-center"
                    v-html="msgError"
                  ></p>
                </v-form>
                <UnitType
                  :loadFunction="loadUnitType"
                  @UnitTypeClose="OpenUnitType = false"
                  :OpenUnitType="OpenUnitType"
                ></UnitType>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="isEditing"
                  @click="InvCancelEdite"
                  :loading="clicked"
                  class="elevation-6"
                  rounded
                  color="error"
                  dark
                  width="150"
                  >Cancel</v-btn
                >
                <v-spacer v-if="isEditing"></v-spacer>
                <v-btn
                  :block="!isEditing"
                  @click="UpdateOrSave"
                  :loading="clicked"
                  class="elevation-6"
                  rounded
                  color="teal darken-3"
                  dark
                  width="150"
                  >{{ isEditing ? "Update" : "Save" }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
// import { tokenMixin } from "../Mixins/tokenMixins.js";
import Category from "@/components/util/Category";
import UnitType from "@/components/util/UnitType";
export default {
  //   mixins: [tokenMixin],
  components: {
    Category,
    UnitType,
  },
  data() {
    return {
      OpenUnitType: false,
      loadUnit: false,
      loadCtgory: false,
      URL: "/AccCharts",
      search: "",
      loading: false,
      ID: "",
      isEditing: false,
      msgError: "",
      clicked: false,
      NewAccount: {
        InvName: null,
        InvCateg: null,
        UnitType: null,
        UnitQty: 1,
      },
      Gategories: [],
      AllInventory: [],
      headers: [
        {
          text: "Category",
          align: "left",
          value: "AccountName",
          class: "teal darken-3 white--text",
        },
        {
          text: "Item Name",
          value: "InvName",
          class: "teal darken-3 white--text",
        },
        {
          text: "Unit",
          value: "UnitType",
          class: "teal darken-3 white--text",
        },
        {
          text: "Unit Qty",
          value: "UnitQty",
          class: "teal darken-3 white--text",
        },

        { text: "Edite", value: "edite", class: "teal darken-3 white--text" },
      ],
      UintType: [
        // { text: "Box", value: "Box" },
        // { text: "Kg", value: "Kg" },
        // { text: "Meter", value: "Meter" },
        // { text: "Yard", value: "Yard" },
        // { text: "liter", value: "liter" }
      ],
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },

  methods: {
    AddUnitType() {
      // console.log("testing");
      this.OpenUnitType = true;
    },
    getReq(url) {
      return this.$store.dispatch("GET_ONLY", url);
    },
    UpdateOrSave() {
      this.NewAccount.InvName = this.NewAccount.InvName.toUpperCase();
      if (this.isEditing) this.OnUpdateInventory();
      else this.OnSaveInventory();
    },
    InvEdite(item) {
      // console.log(item);

      this.ID = item._id;
      this.msgError = "";
      this.isEditing = true;
      this.NewAccount = {
        InvName: item.InvName,
        InvCateg: item.InvCateg,
        UnitType: item.UnitType,
        UnitQty: item.UnitQty || 1,
      };
    },
    InvCancelEdite() {
      this.isEditing = false;
      this.msgError = "";
      this.$refs.InventoryForm.reset();
      this.ID = "";
      this.NewAccount.UnitQty = 1;
    },
    loadUnitType() {
      this.loadUnit = true;
      this.$store
        .dispatch("GET_ONLY", `${this.URL}/UnitType`)
        .then(result => {
          // console.log(result);
          this.UintType = result.data;
          this.loadUnit = false;
        })
        .catch(() => {
          this.loadUnit = false;
        });
    },
    loadCategories() {
      this.loadCtgory = true;
      this.$store
        .dispatch("GET_ONLY", `${this.URL}/Category`)
        .then(result => {
          // console.log(result);
          this.Gategories = result.data;
          this.loadCtgory = false;
        })
        .catch(() => {
          this.loadCtgory = false;
        });
    },
    loadInventoryList() {
      this.loading = true;
      this.$store
        .dispatch("GET_ONLY", this.URL)
        .then(result => {
          // console.log(result);
          this.AllInventory = result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    OnUpdateInventory() {
      // console.log("Updating");
      this.msgError = "";
      if (this.$refs.InventoryForm.validate() && this.ID) {
        this.loading = true;
        this.clicked = true;
        this.NewAccount.InvName = this.NewAccount.InvName.toUpperCase();
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.URL,
            data: { ...this.NewAccount, ID: this.ID },
          })
          .then(() => {
            this.loading = false;
            this.clicked = false;
            this.$refs.InventoryForm.reset();
            this.NewAccount.UnitQty = 1;
            // console.log(result);
            this.ID = "";
            // this.Apartments = result.data;
            this.loadInventoryList();
            this.isEditing = false;
          })
          .catch(err => {
            this.loading = false;
            this.clicked = false;
            if (err.response && err.response.data)
              this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    OnSaveInventory() {
      this.msgError = "";
      if (this.$refs.InventoryForm.validate()) {
        this.loading = true;
        this.clicked = true;
        this.NewAccount.InvName = this.NewAccount.InvName.toUpperCase();
        this.$store
          .dispatch("INSERT_ONLY", {
            url: `${this.URL}`,
            data: this.NewAccount,
          })
          .then(() => {
            this.loading = false;
            this.clicked = false;
            this.NewAccount.InvName = "";
            this.NewAccount.UnitQty = 1;
            this.$refs.InventoryForm.resetValidation();
            // console.log(result);
            this.loadInventoryList();
            // this.AllInventory = result.data;
          })
          .catch(err => {
            this.loading = false;
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
  },
  mounted() {
    // navigator.getBattery().then(function(battery) {
    //   // var level = battery.level;
    //   console.log(battery);
    // });
    this.loading = true;
    this.loadCtgory = true;
    axios
      .all([
        this.getReq(`${this.URL}/Category`),
        this.getReq(`${this.URL}`),
        this.getReq(`${this.URL}/UnitType`),
      ])
      .then(val => {
        this.loading = false;
        this.loadCtgory = false;
        // console.log(val[1].data);
        this.Gategories = val[0].data;
        this.AllInventory = val[1].data;
        this.UintType = val[2].data;
        // console.log(this.UintType);
      })
      .catch(() => {
        this.loading = false;
        this.loadCtgory = false;
      });
    // this.loadRooms();
    // this.loadApartments();
  },
};
</script>
